import Image from 'next/image';

interface SpinningLogoProps {
  size?: number;
  className?: string;
}

export const SpinningLogo = ({ size = 64, className = "" }: SpinningLogoProps) => {
  return (
    <div 
      className={`relative ${className}`}
      style={{ width: size, height: size }}
    >
      <Image
        src="/images/AutoQuity_Logo_Cog_102225.svg"
        alt="Loading..."
        width={size}
        height={size}
        className="animate-spin"
        style={{
          animation: 'spin 2s linear infinite',
        }}
      />
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};
